import styled from 'styled-components';
import {
    black,
    blue,
    containerWidth,
    darkGreen,
    greenPrintDarker,
    greyLight,
    lightGray,
    snowBackground,
    white,
} from '../../styles/Variables';
import selectDivider from '../../static/images/landingPage/divider.png';
import selectArrow from '../../static/images/landingPage/arrow_dropdown.png';
import { CgClose } from 'react-icons/cg';
import { deviceMax, deviceMin } from '../../styles/MediaQuery';

export const Container = styled.div`
    max-width: 620px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    margin: 2.625rem auto 0 auto;

    @media ${deviceMax.tablet} {
        padding: 0 0.5rem;
    }
`;

export const SearchFormsContainer = styled.div`
    width: 100%;

    @media ${deviceMin.tablet} {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
`;

export const Title = styled.h1`
    color: ${blue};
    font-size: 2.5rem;
    letter-spacing: 0.025em;
    margin: 0 0 2.5rem 0;
    line-height: 3.5rem;
`;

export const Subtitle = styled.h2`
    color: ${blue};
    font-size: 1.5rem;
    letter-spacing: 0.025em;
    margin: 0;
    margin-bottom: 0.6rem;
    line-height: 1.5rem;
`;

export const Description = styled.p`
    font-family: Arial, Helvetica, sans-serif;
    font-size: 1rem;
    color: ${black};
    font-weight: 400;
    line-height: 1.4em;
`;

export const SearchFrom = styled.form`
    display: flex;
    flex-direction: column;
`;

export const FormTitle = styled.h3`
    font-family: Arial, Helvetica, sans-serif;
    font-size: 0.8125rem;
    font-weight: 700;
`;

export const ButtonWithCountry = styled.div`
    display: flex;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 0.875rem;
    justify-content: flex-start;
    align-items: center;
    background: url(${selectDivider}) no-repeat 84% 43%, url(${selectArrow}) no-repeat 93% 45%,
        linear-gradient(180deg, #fafbfc 30%, #eff2f5 90%);
    border: 1px solid ${lightGray};
    cursor: pointer;
    padding-left: 0.8rem;
    width: 13rem;
    height: 2.5rem;
    color: ${darkGreen};
    border-radius: 5px;
    appearance: none;
    outline: none;
    margin: 0;
`;

export const SearchTextField = styled.input`
    width: 90%;
    margin-top: 5px;
    outline: none;
    border: 1px solid ${lightGray};
`;

interface CountryBoxProps {
    readonly isActive?: boolean;
}

export const CountryBox = styled.ul<CountryBoxProps>`
    ${(props) =>
        props.isActive
            ? {
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
              }
            : {
                  display: 'none',
              }}
    max-width: 13.8rem;
    margin: 0;
    padding: 0;
    overflow: hidden;
    border: 1px solid ${lightGray};
    border-radius: 3px;
`;

export const CountryList = styled.ul`
    cursor: pointer;
    width: 100%;
    max-height: 240px;
    overflow: scroll;
    overflow-x: hidden;
    margin: 0;
    padding: 0;

    ::-webkit-scrollbar {
        width: 0;
        background: transparent;
    }
`;

interface ListOptionProps {
    readonly isWithoutSearch?: boolean;
    readonly isUsa?: boolean;
}

export const CountryListOption = styled.li<ListOptionProps>`
    display: flex;
    align-items: center;
    font-size: 0.875rem;
    font-family: Arial, Helvetica, sans-serif;
    color: ${darkGreen};
    font-weight: 200;
    word-break: break-all;
    border-bottom: 1px solid ${lightGray};
    ${(props) =>
        props.isWithoutSearch
            ? `
    line-height: 1.2em;
    padding: 3px;
    min-height: 1.2rem;
    &:hover {
        color: ${white}; 
        background: ${darkGreen};
    }
    `
            : `
            
        line-height: 3em;
        padding: 5px 0 5px 1.25rem;

    &:hover {
        background: ${snowBackground};
        color: ${greenPrintDarker};
    }
    `}
`;

export const CountryListOptionLabel = styled(CountryListOption)`
    font-weight: 700;
    padding: 5px 0 5px 10px;
`;

export const SearchButton = styled.button`
    background: linear-gradient(180deg, #fafbfc 30%, #eff2f5 90%);
    border: 1px solid ${lightGray};
    cursor: pointer;
    width: 8rem;
    height: 2.5rem;
    color: ${darkGreen};
    border-radius: 5px;
    appearance: none;
    outline: none;
    margin: 2rem 0;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 0.875rem;
`;

interface PersonContainerProps {
    readonly isVisible?: boolean;
}

export const PersonContainer = styled.div<PersonContainerProps>`
    display: ${(props) => (props.isVisible ? 'block' : 'none')};
    width: 100%;
    background: ${greyLight};
`;

export const PersonBox = styled.div`
    max-width: ${containerWidth};
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    margin: 0 auto;
    margin-top: 3rem;

    @media ${deviceMax.tablet} {
        padding: 15px;
    }
`;

export const CloseButtton = styled.span`
    align-self: flex-end;
    margin-top: 1rem;
    cursor: pointer;

    * {
        font-size: 1.5rem;
        color: ${darkGreen};
    }
`;

export const CloseIcon = styled(CgClose)``;

export const PersonBoxTitle = styled.h3`
    text-transform: uppercase;
    font-size: 0.94rem;
    font-weight: 700;
    letter-spacing: 0.025em;
    margin: 10px 0 6px 0;
`;

export const StateCointainer = styled.div`
    width: 100%;
`;
